import { Directive, Input, HostListener } from '@angular/core';
import { FormGroup, } from '@angular/forms';

/**
 * ページ移動確認ディレクティブ.
 */
@Directive({
  selector: '[sunChangeDetection]'
})
export class ChangeDetectionDirective {

  /** FormGroup. */
  @Input() formGroup: FormGroup;

  /**
   * コンストラクタ.
   */
  constructor() { }

  /**
   * window:beforeunloadイベント検出.
   *
   * ブラウザのリロードボタン、ホームボタン、閉じるボタン、および外部サイトへのリンクのクリックでイベントが発火する.
   * 進むボタン、戻るボタン、またRouterによるアプリ内でのページ移動では発火しない.
   *
   * @param e イベント
   */
  @HostListener('window:beforeunload', ['$event'])
  neforeUnload(e: Event) {
    console.log('this.formGroup.dirty: ' + this.formGroup.dirty);
    // formGroup内の入力項目に変更があった場合は確認ダイアログを表示する
    if (this.formGroup.dirty === true) {
      e.returnValue = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/directive/change-detection.directive.ts